var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.resetValue,
          expression: "resetValue"
        }
      ],
      staticClass: "inline-input"
    },
    [
      _vm.showInput
        ? _c("div", { staticClass: "files-manager-header border-0" }, [
            _c("div", { staticClass: "search w-100" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value,
                    expression: "value"
                  }
                ],
                ref: "inputElm",
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.value },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.updateValue($event)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.value = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-icon",
                  attrs: { type: "submit" },
                  on: { click: _vm.updateValue }
                },
                [_c("i", { staticClass: "font-icon font-icon-ok" })]
              )
            ])
          ])
        : _c("div", { on: { click: _vm.edit } }, [
            !!_vm.value
              ? _c("p", { staticClass: "inline-input-text" }, [
                  _vm._v(_vm._s(_vm.value))
                ])
              : _c("p", {
                  staticClass: "inline-input-text",
                  domProps: { innerHTML: _vm._s(_vm.placeholder) }
                }),
            _vm._v(" "),
            _c("i", { staticClass: "material-icons inline-input-icon" }, [
              _vm._v("edit")
            ])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a41834c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a41834c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/InlineInputComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a41834c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/InlineInputComponent.vue
// module chunks = 0